/**
 * @author Shalini Jha
 * @desc Sticky Side Menu
 */
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import { MaterialUiIcons } from '@gscope-mfe/common-libs';
const ExpandMoreIcon = MaterialUiIcons.ExpandMore;
const { Typography } = MaterialUiCore;
const { Link } = MaterialUiCore;
const { ListItemText } = MaterialUiCore;
const { ListItemIcon } = MaterialUiCore;
const { ListItem } = MaterialUiCore;
const ChevronRightIcon = MaterialUiIcons.ChevronRight;
const AccountCircle = MaterialUiIcons.AccountCircle;
const ChevronLeftIcon = MaterialUiIcons.ChevronLeft;
const { Divider } = MaterialUiCore;
const { ExpansionPanelDetails } = MaterialUiCore;
const { ExpansionPanel } = MaterialUiCore;
const { IconButton, List, ExpansionPanelSummary } = MaterialUiCore;
const { Drawer } = MaterialUiCore;
const { withStyles } = MaterialUiCore;
const drawerWidth = 260;
export const styles = () => ({
    menuContainer: {
        height: '85%',
    },
    drawer: {
        minWidth: drawerWidth,
        flexShrink: 0,
        zIndex: 99,
        whiteSpace: 'nowrap',
        '& .MuiDrawer-paper': {
            top: '3rem',
        },
        '& .MuiListItem-gutters': {
            padding: '15px 16px',
        },
        '& .MuiPaper-elevation1': {
            boxShadow: 'none',
        },
        '& .MuiExpansionPanel-root:before': {
            backgroundColor: 'transparent',
        },
        '& .MuiExpansionPanelSummary-content': {
            margin: '6px 0',
        },
    },
    drawerOpen: {
        '& .MuiDrawer-paper': {
            minWidth: drawerWidth,
            zIndex: 99,
        },
        '& .MuiListItemIcon-root': {
            minWidth: 35,
        },
        '& .MuiExpansionPanelSummary-root': {
            padding: '0 24px 0 5px',
        },
        '& .MuiTypography-body1': {
            paddingTop: 10,
        },
        '& .MuiExpansionPanel-root.Mui-expanded': {
            margin: 0,
        }, // transition: theme.transitions.create('width', {
        //   easing: theme.transitions.easing.sharp,
        //   duration: theme.transitions.duration.enteringScreen,
        // }),
    },
    drawerClose: {
        '& .MuiDrawer-paper': {
            overflowX: 'hidden',
            width: 60,
            zIndex: 99,
        },
        '& .MuiTypography-body1': {
            display: 'none',
        },
        '& .MuiIconButton-edgeEnd': {
            display: 'none',
        }, // transition: theme.transitions.create('width', {
        //   easing: theme.transitions.easing.sharp,
        //   duration: theme.transitions.duration.leavingScreen,
        // }),
    },
    toggleDrawerIcon: {
        position: 'absolute',
        bottom: '4rem',
        width: '100%',
    },
});

const ContextMenuComponent = ({ classes, menuConfig, isOpen, children }) => {
    const [open, setOpen] = React.useState(isOpen);
    const [drawerExpand, setDrawerExpand] = React.useState({});

    const preventDefault = (event) => event.preventDefault();

    const handleDrawerMenu = (listTitle) => setDrawerExpand({ ...drawerExpand, [listTitle]: !drawerExpand[listTitle] });

    let obj = {};
    /**
     * @name mapStateVariables
     * @desc Loops through the menu config and maps the 'isOpen' value
     * in state
     * @param {Object} config
     */

    const mapStateVariables = (config) => {
        if (config && config.length > 0) {
            config.forEach((item) => {
                if (item.hasOwnProperty('isOpen')) {
                    obj = { ...obj, [item.title]: item.isOpen };

                    if (item.sublinks && item.sublinks.length > 0) {
                        mapStateVariables(item.sublinks);
                    }
                }
            });
        }
    };
    /**
     * @name renderAccordion
     * @desc Renders the submenu for context menu
     * @param {Object} ele
     */

    const renderAccordion = (ele) => (
        <ExpansionPanel // expanded={drawerExpand[ele.title] === true}
            // onChange={() => handleDrawerMenu(ele.title)}
            key={ele.title}
        >
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <IconButton>{ele.icon}</IconButton>
                <Typography>{ele.title}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
                <List>
                    {ele.sublinks.map((link) => {
                        if (link.sublinks && link.sublinks.length > 0) {
                            return renderAccordion(link);
                        }

                        return (
                            <Link href={link.link} color="inherit">
                                <ListItem>
                                    <ListItemIcon>{link.icon}</ListItemIcon>
                                    <ListItemText primary={link.title} />
                                </ListItem>
                            </Link>
                        );
                    })}
                </List>
            </ExpansionPanelDetails>
        </ExpansionPanel>
    );
    /**
     * @name renderDrawerComponent
     * @desc Loops through menu config and renders
     *  the contents of drawer component
     * @param {Array} items
     */

    const renderDrawerComponent = (items) =>
        items.map((ele) => {
            if (ele.sublinks && ele.sublinks.length > 0) {
                return renderAccordion(ele);
            }

            return (
                <Link href={ele.link} color="inherit">
                    <ListItem>
                        <ListItemIcon>{ele.icon}</ListItemIcon>
                        <ListItemText>{ele.title}</ListItemText>
                    </ListItem>
                </Link>
            );
        });

    React.useEffect(() => {
        mapStateVariables(menuConfig);
        setDrawerExpand(obj);
    }, []);
    return (
        <Drawer
            variant="permanent"
            className={clsx(classes.drawer, {
                [classes.drawerOpen]: open,
                [classes.drawerClose]: !open,
            })}
        >
            {menuConfig ? <div className={classes.menuContainer}>{renderDrawerComponent(menuConfig)}</div> : children}
            <Divider />
            <List className={classes.toggleDrawerIcon}>
                <ListItem
                    button
                    key="expand"
                    onClick={
                        /* istanbul ignore next */
                        () => setOpen(!open)
                    }
                >
                    <ListItemIcon>{open ? <ChevronLeftIcon /> : <ChevronRightIcon />}</ListItemIcon>
                </ListItem>
            </List>
        </Drawer>
    );
};

ContextMenuComponent.defaultProps = {
    children: <span />,
    menuConfig: [
        {
            title: 'Test',
            icon: <AccountCircle />,
            link: '/test',
        },
        {
            title: 'Test1',
            icon: <AccountCircle />,
            isOpen: true,
            sublinks: [
                {
                    title: 'Test11',
                    link: '/test1',
                    icon: <AccountCircle />,
                },
                {
                    title: 'Test13',
                    isOpen: false,
                    icon: <AccountCircle />,
                    sublinks: [
                        {
                            title: 'Test131',
                            icon: <AccountCircle />,
                        },
                        {
                            title: 'Test132',
                            icon: <AccountCircle />,
                        },
                    ],
                },
            ],
        },
    ],
    isOpen: false,
};
ContextMenuComponent.propTypes = {
    classes: PropTypes.shape({}).isRequired,
    isOpen: PropTypes.bool,
    menuConfig: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            icon: PropTypes.string,
            link: PropTypes.string,
            sublinks: PropTypes.array,
            isOpen: PropTypes.bool,
        }),
    ),
    children: PropTypes.shape({}),
};
export default withStyles(styles)(ContextMenuComponent);
export { ContextMenuComponent };
